// https://github.com/mhasbie/react-leaflet-vectorgrid/issues/16
// https://stackoverflow.com/questions/44472856/how-do-i-add-typescript-definitions-for-leaflet-plugins

// ALTERNATIVE:
// https://github.com/PaulLeCam/react-leaflet/issues/313

import { useEffect } from "react";
import { useLeafletContext } from "@react-leaflet/core";

import L from "leaflet";

import "leaflet.vectorgrid";

import "src/types/vg_types"
//import "./vectorGrid"
//import "src/components/Dashboard/Map/protobuf_custom"

// import { interpolateRainbow, interpolateRdYlGn } from 'd3-scale-chromatic';
// import { color } from "d3-color";

import "src/styles.css";

import { useAppSelector, useAppDispatch } from 'src/hooks';

import { config } from 'src/constants'

const API_URL = config.url.API_URL + 'api/';

// https://codesandbox.io/s/visx-demo-zoom-i-7gqci
export default function VectorGrid(vectorTileOptions: any) {
    console.log("NEW VG");

    const { layerContainer, map } = useLeafletContext();

    //var url = "http://localhost:7800/public.hex_dynamic_" + vectorTileOptions["rast_name"] + "/{z}/{x}/{y}.pbf"; // works w/ hex_2

    // MUST have slash after "tile_server" or we will get redirected:
    // https://stackoverflow.com/questions/1579846/django-returning-http-301
    var url = API_URL + "tile_server/?rast_name=" + vectorTileOptions["rast_name"] + "&z={z}&x={x}&y={y}"

    console.log("PPP url: " + url)

    var vectorGrid = L.vectorGrid.protobuf(url, vectorTileOptions);

    // Update -- this (opacity redraw) doesn't seem to be working properly. Even if it worked,
    // I think it might re-download the data. TODO - look into whether we can get "soft redraws"
    // working for opacity: https://github.com/Leaflet/Leaflet.VectorGrid/issues/159
    // Another approach might be to cache the vector tiles (for fast redraws):
    // https://stackoverflow.com/questions/62345010/client-side-cache-protobuf-vector-tiles-leafletjs

    //useAppSelector((state: any) => {
    //vectorGrid.setFeatureStyle(1, { color: "blue" });
    //});

    // var opacity = useAppSelector((state: any) => {
    //     console.log("APP SEL OPACITY CHANGE: " + state.basic.map.opacity);
    //     //return state.basic.map.opacity;

    //     // Trying to update opacity without requesting new tiles
    //     // https://github.com/Leaflet/Leaflet.VectorGrid/issues/43
    //     // https://leaflet.github.io/Leaflet.VectorGrid/vectorgrid-api-docs.html#vectorgrid-protobuf
    //     vectorGrid.options.vectorTileLayerStyles.dynamic_hex_layer = () => {
    //         return {
    //             fillColor: "red",
    //             fill: true,
    //             //color: "black",
    //             //weight: 0.25,
    //             fillOpacity: state.basic.map.opacity
    //         }
    //     }
    //     vectorGrid.redraw();
    // });


    const container = layerContainer || map;

    useEffect(() => {
        container.addLayer(vectorGrid);
        return () => {
            container.removeLayer(vectorGrid);
        };
    }, []);

    return null;
}